import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Banknote, CreditCard } from "lucide-react";

export default function PaymentModal({
  open,
  onOpenChange,
  total,
  processing,
  onSelectCash,
  onPayCard,
  onPayBizum,
  onPayMbway,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Receber Pagamento</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-center text-3xl font-black text-emerald-600 mb-6">
            €{total.toFixed(2)}
          </p>
          <div className="grid grid-cols-2 gap-3">
            <Button
              className="h-16 bg-emerald-600 hover:bg-emerald-700 font-bold flex-col gap-1"
              onClick={onSelectCash}
              disabled={processing}
            >
              <Banknote className="w-6 h-6" />
              <span className="text-xs">DINHEIRO</span>
            </Button>
            <Button
              className="h-16 bg-blue-600 hover:bg-blue-700 font-bold flex-col gap-1"
              onClick={onPayCard}
              disabled={processing}
            >
              <CreditCard className="w-6 h-6" />
              <span className="text-xs">CARTÃO</span>
            </Button>
            <Button
              className="h-16 bg-[#05C3DD] hover:bg-[#04a8bf] font-bold flex-col gap-1"
              onClick={onPayBizum}
              disabled={processing}
            >
              <span className="text-lg font-black">Biz</span>
              <span className="text-xs">BIZUM</span>
            </Button>
            <Button
              className="h-16 bg-[#E42313] hover:bg-[#c01f10] font-bold flex-col gap-1"
              onClick={onPayMbway}
              disabled={processing}
            >
              <span className="text-lg font-black">MB</span>
              <span className="text-xs">MBWAY</span>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
